import { ReserveBookingCardWrapperType } from "@website/accommodation-ui/hotel-reserve-booking-card/hotel-reserve-booking-card-wrapper/hotel-reserve-booking-card-wrapper.type";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const Component: FC<ReserveBookingCardWrapperType> = (properties) => {
  const { classes = "", children } = properties;
  return (
    <div
      className={`border-outline-thin size-full rounded-xl border bg-white lg:block ${classes}`}
    >
      {children}
    </div>
  );
};

export const HotelReserveBookingCardWrapper = memo(Component, deepCompare);
